"use client";

import clsx from "clsx";

import Skeleton from "@/components/ui/Skeleton";
import { ProductPricesWithDiscount } from "@frend-digital/centra/types";
import styles from "./index.module.css";

const Price = ({
  price,
  className,
  isSoldOut,
  isForcedSalePrice,
}: {
  price: Omit<ProductPricesWithDiscount, "pricelistId">;
  className?: string;
  isSoldOut?: boolean;
  isForcedSalePrice?: boolean;
}) => {
  const isDiscounted = price.productOnSale;

  if (isDiscounted)
    return (
      <div className={clsx(className, styles.discounted__wrapper)}>
        <span className={styles.price__after__discount}>
          <span className="sr-only">
            {"Price after " + price.discountPercent + "% discount."}
          </span>
          <p>{price.price}</p>
        </span>
        {!isForcedSalePrice && (
          <span className={styles.price__before__discount}>
            <span className="sr-only">{"Price before discount."}</span>
            <p className={styles.discount__number}>
              {price.priceBeforeDiscount}
            </p>
          </span>
        )}
      </div>
    );
  return (
    <span
      data-active="1"
      className={clsx(
        className,
        isSoldOut && styles.soldOut,
        isForcedSalePrice && styles.isForcedSalePrice,
      )}
    >
      {price?.price || (
        <span aria-hidden style={{ visibility: "hidden" }}>
          0
        </span>
      )}
    </span>
  );
};

export default Price;

export const PriceSkeleton = () => {
  return <Skeleton style={{ width: "70px" }} height="16px" />;
};
